<template>
  <Question isMSDCustom ref="questionContentRef" :currentQuestion="currentQuestion" :allQuestions="allQuestions" :currentStep="currentStep" @selectedChange="handleSelectedChange"></Question>
</template>

<script>
import Question from '../question/question.vue'

export default {
  components: {
    Question
  },
  props: {
    allQuestions: {
      type: Array,
      default: () => []
    },
    currentStep: {
      required: false
    },
    currentQuestion: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this.$refs.questionContentRef.resetTexareaHeight()
  },
  methods: {
    handleSelectedChange (selectedDisplayValue) {
      this.$emit('selectedChange', selectedDisplayValue)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
